module.exports = __webpack_public_path__ + "static/media/us.fa563627.svg";